import cls from 'classnames';

import useStyles from './styles';
import { NewLabelProps } from './types';

export default function NewLabel({ size = 'medium', className }: NewLabelProps) {
  const classes = useStyles();

  return <span className={cls(classes.root, classes[size], className)}>New</span>;
}
